var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',{staticStyle:{"color":"aliceblue"}},[_vm._v("Page not found! 404")])])
}]

export { render, staticRenderFns }